import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

import { useAuthStore } from '@/stores/auth'

// 三条主路由,组件用 lazy import,M0 阶段只是占位页。
const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue'),
    meta: { public: true },
  },
  {
    path: '/home',
    name: 'lobby',
    component: () => import('@/pages/LobbyPage.vue'),
  },
  {
    path: '/room/:roomId',
    name: 'room',
    component: () => import('@/pages/RoomPage.vue'),
    props: true,
  },
  {
    // /me 路径在后端被 profile REST API (GET /me 返回 JSON) 占用了,
    // 用户 refresh `/me` 会拿到 JSON 而非 SPA, 所以 SPA 路径用 /profile.
    // route name 沿用 'me', 调用方都用 name 引用, 不受 path 改动影响.
    path: '/profile',
    name: 'me',
    component: () => import('@/pages/ProfilePage.vue'),
  },
  // 兼容老书签 / 老链接: client-side 把 /me 重定向到 /profile.
  // 只对"已进入 SPA 后内部导航 /me"和"用户从 / 起步, Vue Router 接管"
  // 的场景生效. 如果用户从浏览器地址栏直接打开 /me, 后端会先命中 REST
  // API 返回 JSON, redirect 不会发生 — 这是没法绕开的, 见 app/main.py.
  { path: '/me', redirect: '/profile' },
  { path: '/',         redirect: '/home' },
  { path: '/:pathMatch(.*)*', redirect: '/home' },
]

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

// 守卫:未登录访问私有路由 → 跳 /login;已登录访问 /login → 跳 /home。
router.beforeEach((to) => {
  const auth = useAuthStore()
  if (!auth.token && !to.meta.public) return { name: 'login' }
  if (auth.token && to.meta.public)   return { name: 'lobby' }
  return true
})
